import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare `/account/api/$appId` has no content of its own — redirect to the default Settings section.
export const Route = createFileRoute('/_app/account/api/$appId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/account/api/$appId/settings', params: { appId: params.appId } })
  },
})
